import React, { useEffect } from 'react';
import { Box, Grid } from '@ublend-npm/aulaui-core';
import widgetsLibrary, { HOME_SPACES_WIDGET_IDS } from './widgetsLibrary';
import SpaceWidgetSection from './widgets/spaceWidget';
import { useDispatch, useSelector } from 'react-redux';
import { fetchWidgetPreferences } from '../../../actions/home/widgetPreferences';
import { WidgetPreference } from '@core/types/state';

const HOME_PAGE_HORIZONTAL_PADDING = '2rem';
const HOME_SPACES_WIDGET_ID_SET = new Set<string>(HOME_SPACES_WIDGET_IDS);

const Widgets = () => {
  const userPreferences: WidgetPreference[] | null = useSelector(
    (state: any) => state.home?.widgetPreferences
  );

  const widgetsToRender = widgetsLibrary
    .map((widget) => {
      const pref = (userPreferences || []).find(
        (p: any) => p.widgetId === widget.id
      );
      return {
        ...widget,
        isHidden: pref ? pref.isHidden : false,
      };
    })
    .filter((widget) => !widget.isHidden);

  const isWidgetVisible = (widgetId: string) =>
    widgetsToRender.some((widget) => widget.id === widgetId);

  const showSpacesSection = HOME_SPACES_WIDGET_IDS.some(isWidgetVisible);
  const otherWidgets = widgetsToRender.filter(
    (widget) => !HOME_SPACES_WIDGET_ID_SET.has(widget.id)
  );

  return (
    <>
      {showSpacesSection ? (
        <Box
          data-home-spaces-full-width
          sx={{
            width: '100vw',
            ml: 'calc(50% - 50vw)',
            boxSizing: 'border-box',
            mb: 3,
          }}
        >
          <Box
            sx={{
              px: HOME_PAGE_HORIZONTAL_PADDING,
              minWidth: 0,
              width: '100%',
              boxSizing: 'border-box',
            }}
          >
            <SpaceWidgetSection
              showRoleToggle={isWidgetVisible('home-switchrole-widget')}
              showGreeting={isWidgetVisible('home-greeting-widget')}
              showSpaceCarousel={isWidgetVisible('home-space-widget')}
            />
          </Box>
        </Box>
      ) : null}

      <Box
        sx={{
          px: HOME_PAGE_HORIZONTAL_PADDING,
          pb: '2rem',
          pt: showSpacesSection ? 0 : '1.5rem',
          boxSizing: 'border-box',
        }}
      >
        <Grid container spacing={3} flexWrap="wrap">
          {otherWidgets.map((widget) => (
            <Grid
              id={widget.id}
              size={widget.size}
              aria-label={widget?.ariaLabel}
              sx={{ minWidth: 0 }}
            >
              {widget.component}
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

const HomePage = () => {
  const dispatch = useDispatch();

  const widgetPreferences: WidgetPreference[] | null = useSelector(
    (state: any) => state.home?.widgetPreferences
  );

  useEffect(() => {
    document.title = 'Home - Aula';
    if (!widgetPreferences) {
      dispatch(fetchWidgetPreferences() as any);
    }
  }, [dispatch, widgetPreferences]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={{
        height: '100%',
        minHeight: 0,
        overflowY: 'auto',
        overflowX: 'hidden',
        boxSizing: 'border-box',
      }}
      gap="1.5rem"
      pt="1.5rem"
    >
      <Widgets />
    </Box>
  );
};

export default HomePage;
